'use client';

import { useRouter } from 'next/navigation';
import { useEffect } from 'react';
import type { Product, Variant } from 'types/product';

import { gTagViewItem } from '@/utils/googleTags';

type Props = {
    product: Product;
    variant: Variant | undefined;
    currency: string;
};

export default function Seo(props: Props) {
    const router = useRouter();
    const { product, variant, currency } = props;

    useEffect(() => {
        gTagViewItem(variant, product, currency);
    }, [product, variant, currency]);

    useEffect(() => {
        const url = new URL(window.location.href);
        url.searchParams.delete('pv2');
        router.replace(url.toString(), undefined);
    }, [router]);

    return null;
}
